import {
    CLOSE_QUICKSHOP,
    LOAD_QUICKSHOP,
    SAVE_QUICKSHOP_ITEM
} from '../enums/quickshopEnums';

import { reduceProductActions } from './productReducer';
import { isQuickshop } from '../utils/quickshopUtils';

/**
 * Quickshop product reducer.  Reduces into 'quickshop' in the state
 *
 * @param state The full state object.  This should _ONLY_ be used to determine if Quickshop is open
 * @param productState product subsection of the state
 * @param action action passed
 * @returns reduced product state
 */
export function quickshopReducer(state = {}, quickshopState = {}, action = {}) {
    switch (action.type) {
        case CLOSE_QUICKSHOP:
            return {};

        case LOAD_QUICKSHOP:
            return action.payload;

        case SAVE_QUICKSHOP_ITEM:
            return Object.assign({}, quickshopState, {
                item: action.payload
            });

        default:
            if (!isQuickshop(state)) {
                return quickshopState;
            }

            // Run the actions through the Product Reducer. Quickshop and PDP share the same
            //  actions
            // This reduces into quickshop.product
            return Object.assign({}, quickshopState, {
                product: Object.assign({}, quickshopState.product,
                    reduceProductActions(quickshopState.product, action))
            });
    }
}
